<script setup lang="js">

import {ref} from "vue";
import ContextColors from "@/components/ContextColors.vue";
import Context from "@/components/Context.vue";
import JustCreateTitle from "@/components/JustCreateTitle.vue";

const jcdt = ref("https://cos5.51tgqj.com/techming/img/jcdt@2x.png");
const show = ref("https://cos5.51tgqj.com//2025/07/02/138b37b042724d7481d47bb2f4733aed.png");
</script>

<template>
  <div>
    <context-colors color="bg-[#ffffff]" class="flex justify-center text-center">
      <el-image :src="jcdt" class="w-2/3"/>
    </context-colors>
    <context>
      <just-create-title text="加入我们"/>
      <div>
        <div class="flex text-white text-3xl md:text-3xl lg:text-[1.8rem]">
          <div class="w-2 h-full bg-white">&ensp;</div>
          <div class="ml-4 md:ml-4 lg:ml-8">产品/设计</div>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-10 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">产品经理</div>
        <div class="">
          <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">UI设计</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">平面设计</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="mt-10 md:mt-10 lg:mt-14">
        <div class="flex  text-white text-3xl md:text-3xl lg:text-[1.8rem]">
          <div class="w-2 h-full bg-white">&ensp;</div>
          <div class="ml-4 md:ml-4 lg:ml-8">技术开发</div>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-10 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">web前端开发工程师</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">java开发工程师</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="mt-10 md:mt-10 lg:mt-14">
        <div class="flex  text-white text-3xl md:text-3xl lg:text-[1.8rem]">
          <div class="w-2 h-full bg-white">&ensp;</div>
          <div class="ml-4 md:ml-4 lg:ml-8">市场</div>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-10 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">市场营销</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">项目执行</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">招聘专员</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">阵地运营师</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>
      <div class="flex bg-[#D3D3D3] w-full flex justify-between mt-2 p-2 items-center">
        <div class="line-clamp-1 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-center">活动策划师</div>
        <div class="">
              <img :src="show" class="w-[2rem] md:w-[2rem] lg:w-[3rem]"/>
        </div>
      </div>


      <just-create-title text="联系方式"/>
      <div class="text-white lg:flex lg:justify-between">
        <div class="basis-1/2">
          <div class="text-3xl md:text-3xl lg:text-[1.8rem]">重庆铭匠科技（九龙后街数智零工驿站）</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">地址：重庆九龙坡区翼龙路30号12栋1单元1层</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">电话：023-68086763</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">手机：13708306888</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">邮箱：3136928717@qq.com</div>
        </div>
        <div class="basis-1/2 mt-10 md:mt-10 lg:mt-0">
          <div class="text-3xl md:text-3xl lg:text-[1.8rem] md:mt-4">上海骄之阳企划</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">地址：上海市长宁区延安西路1590号717室</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">手机：17317927016</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">邮箱：3136928717@qq.com</div>
        </div>
      </div>
      <div class="text-white lg:flex lg:justify-between mt-10">
        <div class="basis-1/2">
          <div class="text-3xl md:text-3xl lg:text-[1.8rem] ">川渝高竹新区数智零工市场</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">地址：四川省广安市邻水县汉渝路775号</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">手机：13998118456</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">邮箱：3136928717@qq.com</div>
        </div>
        <div class="basis-1/2 mt-10 md:mt-10 lg:mt-0">
          <div class="text-3xl md:text-3xl lg:text-[1.8rem]  ">广安白塔微创园</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">地址：四川广安市广安区朝阳大道二段683号</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">手机：13054564666</div>
          <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] mt-4">邮箱：3136928717@qq.com</div>
        </div>
      </div>
    </context>


  </div>
</template>

<style scoped>

</style>
